export const Config = {
                    apiEndpoint: "https://3q0g4zskwd.execute-api.eu-west-2.amazonaws.com/prod",
                    acceptingSignup: false
                }
                